export const REQUIRED_ERRORS = {
  email: "Email is required",
  password: "Password is required",
  newPassword: "New password is required",
  start_date: "Please chose start date",
  name: "Please enter name",
  regulatory_type: "Please chose regulatory type",
  regulatory: "Please enter regulatory",
  telephone: "Please enter phone number",
  consortia: "Please chose consortia",
  affiliation: "Please chose affiliation",
  title: "Please enter your title",
  firstName: "Please enter first name",
  surname: "Please enter second name",
  personalPhoneNumber: "Please enter your phone number",
  position: "Please chose position",
  confirmPassword: "Password confirmation is required",
  phone: "Please enter phone number",
  given_name: "Please enter first name",
  last_name: "Please enter second name",
  dayOfBirth: "Please enter day of birth",
  monthOfBirth: "Please enter month of birth",
  yearOfBirth: "Please enter year of birth",
  nationality: "Please enter citizenship",
  address: "Please enter address",
  address1: "Please enter 1st line address",
  address2: "Please enter 2nd line address",
  city: "Please enter city",
  state: "Please enter state",
  country: "Please enter country",
  zip: "Please enter zip code",
};

export const WRONG_FORMAT_ERRORS = {
  email: "Not valid email",
  website: "Not valid URL",
};

export const NOT_POSITIVE_ERRORS = {
  staterooms: "Not positive integer",
};

export const NOT_EQUAL_ERRORS = {
  confirmPassword: "Passwords not equal",
};

export const TOO_SHORT_ERRORS = {
  password: "Password must be at least 8 symbols",
};

export const WRONG_INTEGER_ERRORS = {
  staterooms: "Value should between 1 and 3",
  rooms: "Value should between 1 and 3",
};
